/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Nabis NY Web API
 * Nabis NY Web API docs
 * OpenAPI spec version: 1.0
 */
import axios from 'axios';
import type { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';
import useSwr from 'swr';
import type { SWRConfiguration, Key } from 'swr';
import type {
  FeatureFlagFindOneResponseDto,
  FeatureFlagControllerFindOneParams,
  FeatureFlag,
} from '../nabisNYWebAPI.schemas';

export const featureFlagControllerFindOne = (
  featureFlag: FeatureFlag,
  params?: FeatureFlagControllerFindOneParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<FeatureFlagFindOneResponseDto>> => {
  return axios.get(`/api/v1/feature-flag/${featureFlag}`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getFeatureFlagControllerFindOneKey = (
  featureFlag: FeatureFlag,
  params?: FeatureFlagControllerFindOneParams,
) => [`/api/v1/feature-flag/${featureFlag}`, ...(params ? [params] : [])] as const;

export type FeatureFlagControllerFindOneQueryResult = NonNullable<
  Awaited<ReturnType<typeof featureFlagControllerFindOne>>
>;
export type FeatureFlagControllerFindOneQueryError = AxiosError<unknown>;

export const useFeatureFlagControllerFindOne = <TError = AxiosError<unknown>>(
  featureFlag: FeatureFlag,
  params?: FeatureFlagControllerFindOneParams,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof featureFlagControllerFindOne>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
    axios?: AxiosRequestConfig;
  },
) => {
  const { swr: swrOptions, axios: axiosOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!featureFlag;
  const swrKey =
    swrOptions?.swrKey ?? (() => (isEnabled ? getFeatureFlagControllerFindOneKey(featureFlag, params) : null));
  const swrFn = () => featureFlagControllerFindOne(featureFlag, params, axiosOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};
